export const ERRORS = Object.freeze({
  TOKEN_EXPIRED:"TokenExpiredError: jwt expired",
}) 
